import { useEffect, useState } from "react";

import { aitbSearchPeriods } from "../../../interface/MainInterface";
import { HttpUnAuthApi } from "../../../interface/unauth-api";

// CSS
import "./SearchNavigation.css";
import { useNavigate } from "react-router-dom";

interface propsType {
  selectedPeriod: string | null;
  selectedCategory: any;
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const SearchNavigation = (props: propsType) => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<any>([]);
  const [showCategory, setShowCateroty] = useState(false); // 카테고리 선택 버튼 제어용

  useEffect(() => {
    const get_category_list = async () => {
      const param: any = {
        command: "get_category_list",
        pk: "trendreport#category",
        sk: "all",
      };
      const res = await unAuthAPI.post(param);
      if (res.code === "200") {
        setCategories(res.response.category_list);
      } else {
        console.error("[ERROR] get_category_list : ", res.response.error_msg);
      }
    };

    get_category_list();
    return () => {
      setCategories([]);
      setShowCateroty(false);
    };
  }, []);

  // 카테고리 선택
  const selectCategory = (category: any) => {
    if (category && category.key === "globalcollection") {
      // 런웨이 진입 플래그 설정
      navigate('/runway', {state:{"resetFlag":true}});
    } else {
      props.callback({ command: "selected_category", value: category });
    }
    setShowCateroty(false); // 카테고리 선택 Dropdown 닫기
  };

  return (
    <>
      <article className="article-02 no-margin">
        <div className="brief-list-wrap">
          <div className="option-wrap">
            <div className="search-top">
              <div className="category">
                <div className={showCategory ? "select_wrap active" : "select_wrap"}>
                  <ul className="default_option">
                    <li
                      onClick={() => {
                        setShowCateroty(!showCategory);
                      }}
                    >
                      {props.selectedCategory === null ? "전체" : props.selectedCategory.value}
                    </li>
                  </ul>
                  <ul className="select_ul">
                    <li
                      onClick={() => {
                        selectCategory(null);
                      }}
                    >
                      전체
                    </li>
                    {categories.map((category: any, index: number) => (
                      <li
                        key={`category-${index}`}
                        onClick={() => {
                          selectCategory(category);
                        }}
                      >
                        {category.value}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="period-wrap">
              <div className="tabs">
                {aitbSearchPeriods.map((data: any, index: number) => (
                  <div key={`radio-${index + 1}`} className="tab">
                    <input
                      type="radio"
                      id={`radio-${index + 1}`}
                      name="tabs"
                      onChange={() => {
                        props.callback({ command: "selected_period", value: data.key });
                      }}
                    />
                    <label className={props.selectedPeriod === data.key ? "tab color-white" : "tab"} htmlFor={`radio-${index + 1}`}>
                      {data.title}
                    </label>
                  </div>
                ))}

                <span
                  className={
                    props.selectedPeriod === "recent"
                      ? "glider period1"
                      : props.selectedPeriod === "week"
                      ? "glider period2"
                      : props.selectedPeriod === "month"
                      ? "glider period3"
                      : "glider period4"
                  }
                ></span>
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default SearchNavigation;
